
import React from "react";

export default function BotaoContato({
    number = '554792513502', 
    mensagem = 'Olá! Gostaria de saber mais sobre a solução de atendimento.',
    text = 'Converse conosco',
    className,
    icon,
    style}) {

  const linkContato = `https://wa.me/${number}?text=${encodeURIComponent(mensagem)}`;

  return (
    <a
      href={linkContato}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
    >
      {
        icon ? icon : <></>
      }
      <span>{text}</span>
    </a>
  );
}
